/* tslint:disable */
/* eslint-disable */
/**
 * FireBIM API
 * API definitions for FireBim
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { AssetListRequest } from '../models';
// @ts-ignore
import { AssetListResponse } from '../models';
// @ts-ignore
import { AssetResponse } from '../models';
// @ts-ignore
import { AssetUpdateRequest } from '../models';
// @ts-ignore
import { FilterListRequest } from '../models';
// @ts-ignore
import { FilterSchemaResult } from '../models';
// @ts-ignore
import { ProblemDetails } from '../models';
/**
 * AssetsModuleApi - axios parameter creator
 * @export
 */
export const AssetsModuleApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Gets list of filters for issues.
         * @param {FilterListRequest} [request] Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetFiltersGet: async (request?: FilterListRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/Filters`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)

            if (request != null) {
                localVarHeaderParameter['request'] = typeof request === 'string' 
                    ? request 
                    : JSON.stringify(request);
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Get list of assets associated with given file version.
         * @param {AssetListRequest} [assetListRequest] Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetListPost: async (assetListRequest?: AssetListRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/List`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetListRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * 
         * @summary Updates specified asset associated with given file version.
         * @param {AssetUpdateRequest} [assetUpdateRequest] Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetUpdatePost: async (assetUpdateRequest?: AssetUpdateRequest, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/Asset/Update`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication oauth2 required
            // oauth required
            await setOAuthToObject(localVarHeaderParameter, "oauth2", [], configuration)


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(assetUpdateRequest, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * AssetsModuleApi - functional programming interface
 * @export
 */
export const AssetsModuleApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = AssetsModuleApiAxiosParamCreator(configuration)
    return {
        /**
         * 
         * @summary Gets list of filters for issues.
         * @param {FilterListRequest} [request] Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetFiltersGet(request?: FilterListRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<FilterSchemaResult>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetFiltersGet(request, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Get list of assets associated with given file version.
         * @param {AssetListRequest} [assetListRequest] Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetListPost(assetListRequest?: AssetListRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetListResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetListPost(assetListRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * 
         * @summary Updates specified asset associated with given file version.
         * @param {AssetUpdateRequest} [assetUpdateRequest] Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async assetUpdatePost(assetUpdateRequest?: AssetUpdateRequest, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<AssetResponse>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.assetUpdatePost(assetUpdateRequest, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * AssetsModuleApi - factory interface
 * @export
 */
export const AssetsModuleApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = AssetsModuleApiFp(configuration)
    return {
        /**
         * 
         * @summary Gets list of filters for issues.
         * @param {FilterListRequest} [request] Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetFiltersGet(request?: FilterListRequest, options?: any): AxiosPromise<FilterSchemaResult> {
            return localVarFp.assetFiltersGet(request, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Get list of assets associated with given file version.
         * @param {AssetListRequest} [assetListRequest] Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetListPost(assetListRequest?: AssetListRequest, options?: any): AxiosPromise<AssetListResponse> {
            return localVarFp.assetListPost(assetListRequest, options).then((request) => request(axios, basePath));
        },
        /**
         * 
         * @summary Updates specified asset associated with given file version.
         * @param {AssetUpdateRequest} [assetUpdateRequest] Request
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        assetUpdatePost(assetUpdateRequest?: AssetUpdateRequest, options?: any): AxiosPromise<AssetResponse> {
            return localVarFp.assetUpdatePost(assetUpdateRequest, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * AssetsModuleApi - object-oriented interface
 * @export
 * @class AssetsModuleApi
 * @extends {BaseAPI}
 */
export class AssetsModuleApi extends BaseAPI {
    /**
     * 
     * @summary Gets list of filters for issues.
     * @param {FilterListRequest} [request] Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsModuleApi
     */
    public assetFiltersGet(request?: FilterListRequest, options?: AxiosRequestConfig) {
        return AssetsModuleApiFp(this.configuration).assetFiltersGet(request, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Get list of assets associated with given file version.
     * @param {AssetListRequest} [assetListRequest] Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsModuleApi
     */
    public assetListPost(assetListRequest?: AssetListRequest, options?: AxiosRequestConfig) {
        return AssetsModuleApiFp(this.configuration).assetListPost(assetListRequest, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * 
     * @summary Updates specified asset associated with given file version.
     * @param {AssetUpdateRequest} [assetUpdateRequest] Request
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof AssetsModuleApi
     */
    public assetUpdatePost(assetUpdateRequest?: AssetUpdateRequest, options?: AxiosRequestConfig) {
        return AssetsModuleApiFp(this.configuration).assetUpdatePost(assetUpdateRequest, options).then((request) => request(this.axios, this.basePath));
    }
}
